var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"gutter":20}},[_c('a-col',{attrs:{"span":18}},[_vm._v("\n    声纹加密功能暂未实现......\n  ")]),_c('a-col',{attrs:{"span":6}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }